
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Counter } from '@/api';
import CounterROIModal from '@/pages/counters/CounterROIModal.vue';
import CounterROI from './CounterROI.vue';

@Options({
  name: 'CounterROIList',
  components: { CounterROI, CounterROIModal }
})
export default class CounterROIList extends Vue {
  @Prop({ type: Object, required: true })
  readonly model!: Counter;

  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  modalEnabled = false;
  cameraStartIndex: number | null = null;

  get cameras() {
    return [...this.model.cameras].sort((a, b) => a - b);
  }

  showModal(cameraStartIndex: number) {
    this.modalEnabled = true;
    this.cameraStartIndex = cameraStartIndex;
  }
}
